import client from './client';

// Function to get employees based on pay period ID, type of timesheet, and supervisor ID
export const getLocations = async () => {
    try {

      // Make the API request to fetch the employees' data based on the constructed endpoint and parameters
      const response = await client.get("/admin/locations");

      // Log the response data to the console
      console.log(response.data);

      // Return the response object, which contains the employees' data
      return response;

    } catch (error) {
      // Log any errors that occur during the fetch process
      console.error("Error fetching locations:", error);

      // Throw an error to indicate that fetching employees failed
      throw new Error("Failed to fetch locations");
    }
};